<app-brand-form-wrapper
  #formWrapper
  [config]="config"
  [editMode]="false"
  [viewMode]="false"
></app-brand-form-wrapper>
